import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'
import {
  BibliographyDetailRealTabType,
  BibliographyDetailSetTabType,
  Prefix
} from '@/types'

export interface SelectBibliographyDetailReal {
  prefix: Prefix
  collectionNo: string
  bibliographyId?: number
  marcNo?: string
}

export interface ModalBibliographyDetailRealStoreInterface {
  bibliographyRealId: number
  marcNo?: string
  isCollectionSelect?: boolean
  isBibliographySelectProcess?: boolean
  tabType: BibliographyDetailRealTabType
  bibliographyContentId?: number
  userId?: string
  onBackCondition?: () => void
  onBackResult?: () => void
  onSelect?: (value: SelectBibliographyDetailReal) => void
  onToggleSet?: (
    bibliographyId: number,
    tabType: BibliographyDetailSetTabType
  ) => void
}

@Module({
  name: 'ModalBibliographyDetailRealStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalBibliographyDetailRealStore extends BaseStore {
  _isOpen: boolean = false

  _isCollectionSelect: boolean = false

  _isBibliographySelectProcess: boolean = false

  _bibliographyRealId: number = 0

  _marcNo: string = ''

  _tabType: BibliographyDetailRealTabType =
    BibliographyDetailRealTabType.Collection

  _bibliographyContentId: number = 0

  _userId: string = ''

  _backConditionCallback?: () => void

  _backResultCallback?: () => void

  _selectCallback?: (value: SelectBibliographyDetailReal) => void

  _toggleSetCallback?: (
    bibliographyId: number,
    tabType: BibliographyDetailSetTabType
  ) => void

  get isOpen(): boolean {
    return this._isOpen
  }

  get isCollectionSelect(): boolean {
    return this._isCollectionSelect
  }

  get isBibliographySelectProcess(): boolean {
    return this._isBibliographySelectProcess
  }

  get bibliographyRealId(): number {
    return this._bibliographyRealId
  }

  get marcNo(): string {
    return this._marcNo
  }

  get tabType(): BibliographyDetailRealTabType {
    return this._tabType
  }

  get bibliographyContentId(): number {
    return this._bibliographyContentId
  }

  get userId(): string {
    return this._userId
  }

  @Mutation
  public open(params: ModalBibliographyDetailRealStoreInterface) {
    this._isOpen = true
    this._isCollectionSelect = params.isCollectionSelect ?? false
    this._isBibliographySelectProcess =
      params.isBibliographySelectProcess ?? false
    this._bibliographyRealId = params.bibliographyRealId
    this._marcNo = params.marcNo ?? ''
    this._tabType = params.tabType ?? BibliographyDetailRealTabType.Collection
    this._bibliographyContentId = params.bibliographyContentId ?? 0
    this._userId = params.userId ?? ''
    this._backConditionCallback = params.onBackCondition
    this._backResultCallback = params.onBackResult
    this._selectCallback = params.onSelect
    this._toggleSetCallback = params.onToggleSet
  }

  @Mutation
  public close() {
    this._isOpen = false
  }

  @Mutation
  public backCondition() {
    if (this._backConditionCallback) {
      this._backConditionCallback()
    }

    this._isOpen = false
  }

  @Mutation
  public backResult() {
    if (this._backResultCallback) {
      this._backResultCallback()
    }

    this._isOpen = false
  }

  @Mutation
  public select(value: SelectBibliographyDetailReal) {
    if (this._selectCallback) {
      this._selectCallback(value)
    }

    // 選択後、エラーが発生した場合、ダイアログ表示を閉じたくないのでこの時点ではfalseを設定しない
  }

  @Mutation
  public toggleSet(value: {
    bibliographyId: number
    tabType: BibliographyDetailSetTabType
  }) {
    if (this._toggleSetCallback) {
      this._toggleSetCallback(value.bibliographyId, value.tabType)
    }

    this._isOpen = false
  }
}
